import { render, staticRenderFns } from "./TurnAssigner.vue?vue&type=template&id=81089b9a&lang=pug&"
import script from "./TurnAssigner.vue?vue&type=script&lang=js&"
export * from "./TurnAssigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81089b9a')) {
      api.createRecord('81089b9a', component.options)
    } else {
      api.reload('81089b9a', component.options)
    }
    module.hot.accept("./TurnAssigner.vue?vue&type=template&id=81089b9a&lang=pug&", function () {
      api.rerender('81089b9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TurnAssigner.vue"
export default component.exports